import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import PropTypes from 'prop-types';
import './AdminViewUser.scss';
import ViewResellerProfile from './ViewResellerProfile';
import ViewDistributorProfile from './ViewDidtributorProfile';
import ViewDevArchProfile from './ViewDevArchProfile';
import ViewAdminProfile from './ViewAdminProfile';
import ViewEmployeeProfile from './ViewEmployeeProfile';
import request from '../../utils/agent';
import Loader from 'components/Loader';


export default class AdminViewUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: { },
            userId: null,
            loaded: false,
            companyId: null,
            compLoaded: false,
            csmLoaded: false,
            error: false,
        };
    }

    componentDidMount() {
        const {id} = this.props.match.params;
        this.setState({userId: id});
        this.getRoleData(id);
        this.getCSMData();
        if(this.state.role.name != 'pOwner' && this.state.role.name != 'owner' && this.state.role.name != 'admin') {
            this.getCompanyData(id);
        }
    }

    getCSMData() {
        request.get("/api/csms")
          .then(resp => {
              this.setState({
                  csms: resp.body.csms,
                  csmLoaded: true
              });
          })
    }

    getRoleData(id) {
        return new Promise((resolve, reject) => {
            request.get(`/api/user/${id}`)
                .then(resp => {
                    this.setState({
                        role: resp.body.user.role,
                        loaded: true,
                    })
                    resolve(resp.body);
                })
                .catch(err => {
                    console.error('error', err);
                    this.setState({error: true});
                })

        });
    }

    getCompanyData(id) {
        return new Promise((resolve, reject) => {
            request.get(`/api/user/${id}`)
                .then(resp => {
                    this.setState({
                        companyId: resp.body.user.company.id,
                        compLoaded: true,
                    })
                    resolve(resp.body);
                })
                .catch(err => {
                    console.error('error', err);
                })

        })
    }



    render() {

        //console.log('role', this.state.role);
        //console.log('compId', this.state.companyId);
        //console.log('userId', this.state.userId);



        return(
            <section className='profile--container'>
                <h1>Profile</h1>
                {this.state.role.name === 'pOwner' || this.state.role.name === 'owner' || this.state.role.name === 'admin' ?
                    <div>
                        {this.state.loaded === true ?
                            <ViewAdminProfile id={this.state.userId}/> : null
                        }
                    </div>:
                    <div>
                        {this.state.compLoaded === true && this.state.loaded === true && this.state.csmLoaded === true ?
                            <div>
                                {this.state.role.name === 'user' || this.state.role.name === 'electrician' ?
                                    <ViewResellerProfile id={this.state.userId} companyId={this.state.companyId} csms={this.state.csms}/> :
                                    null
                                }
                                {this.state.role.name === 'distributor' ?
                                    <ViewDistributorProfile id={this.state.userId} companyId={this.state.companyId} csms={this.state.csms}/> :
                                    null
                                }
                                {this.state.role.name === 'developer' || this.state.role.name === 'architect' || this.state.role.name === 'ownermanager' ?
                                    <ViewDevArchProfile id={this.state.userId} companyId={this.state.companyId} csms={this.state.csms}/> :
                                    null
                                }
                                {this.state.role.name === 'installer' ?
                                    <ViewEmployeeProfile id={this.state.userId} companyId={this.state.companyId} csms={this.state.csms}/> :
                                    null
                                }
                            </div> :
                            <Loader/>
                        }
                    </div>
                }

            </section>
        );
    }
};


// WEBPACK FOOTER //
// ./src/routes/AdminViewUser/index.js